var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 208,
    viewBox: "0 0 205 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M137.839 171.704C174.403 152.014 188.083 106.41 168.392 69.846C148.702 33.2816 103.099 19.6024 66.5345 39.2926C29.97 58.9828 16.2908 104.586 35.981 141.151C55.6712 177.715 101.275 191.394 137.839 171.704Z",
    fill: "#D8DBE8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M138.781 168.56C175.345 148.87 189.025 103.266 169.334 66.702C149.644 30.1376 104.041 16.4583 67.4765 36.1485C30.9121 55.8387 17.2328 101.442 36.923 138.007C56.6132 174.571 102.217 188.25 138.781 168.56Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.81f81c4d86103c1675bbd3de6645b542.svg";
export { ForwardRef as ReactComponent };